<template v-if="billdata">
    <div>
        <div
          class="modal center-modal fade"
          id="confirmPaymentBill"
          tabindex="-1"
          aria-labelledby="confirmPaymentBill"
          aria-hidden="true"
        >
          <div 
            class="modal-dialog modal-dialog-center"
            style="margin-bottom: 50px;"
          >
            <div class="modal-content">
              <div
                class="modal-header pt-4 pb-2"
                style="margin: 0 14px; padding: inherit;"
              >
                <h5 class="modal-title title-modal" id="rc">
                  Confirm Payement
                </h5>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <!-- <hr /> -->
              <div class="modal-body">
                <h2 class="billAmount">₦{{ Number(billdata.amount - discountPoint).toLocaleString() }}</h2>
                <h5 class="discount-amount" v-if="applyDiscount && discountPoint != ''">₦{{ Number(billdata.amount).toLocaleString() }}</h5>
                <div class="confirmation-holder">
                  <div class="discount-section">
                    
                    <div v-if="billdata.reward">
                      <h6>COVA</h6>
                      <h5>{{ (Number(billdata.reward.cova_points) * 2).toLocaleString()}} points</h5>
                    </div>
                    <div v-if="billdata.reward">
                      <h6>COVA Reward</h6>
                      <h5>+{{ billdata.reward.reward_to_get }} points</h5>
                    </div>
                  </div>
                  <!-- <hr> -->
                  <div class="discount-section">
                    <div v-if="billdata.paymentType == 'Electricity' || billdata.paymentType == 'cable'">
                      <h6>Transaction fee</h6>
                      <h5>₦{{ Number(billdata.statutory_charge).toLocaleString() }}</h5>
                    </div>
                    <div>
                      <h6>Payment type</h6>
                      <h5>Bills - {{billdata.paymentType}}</h5>
                    </div>
                    <div>
                      <h6>Payment method</h6>
                      <h5>{{ billdata.paymentMethod }}</h5>
                    </div>
                    <div v-if="billdata.network">
                      <h6>Network</h6>
                      <h5>{{ billdata.network }}</h5>
                    </div>
                    <div v-if="billdata.paymentType == 'Electricity'">
                      <h6>Meter number</h6>
                      <h5>{{ billdata.meter_no }}</h5>
                    </div>
                    <div v-if="billdata.paymentType == 'Electricity' || 'cable'">
                      <h6>Type</h6>
                      <h5>{{ billdata.disco }}</h5>
                    </div>
                    <div v-if="billdata.paymentType == 'Electricity' || 'cable'">
                      <h6>Package</h6>
                      <h5>{{ billdata.vend_type }}</h5>
                    </div>
                    <div>
                      <h6>Phone number</h6>
                      <h5>{{ billdata.phone }}</h5>
                    </div>
                    <div v-if="billdata.paymentType == 'Electricity' || billdata.paymentType == 'cable'">
                      <h6>Name</h6>
                      <h5>{{ billdata.customerName }}</h5>
                    </div>
                    <div v-if="billdata.paymentType == 'Electricity' || billdata.paymentType == 'cable'">
                      <h6>Address</h6>
                      <h5>{{ billdata.address }}</h5>
                    </div>
                    <hr>
                    <div v-if="billdata.reward">
                      <h6>Available discount</h6>
                      <h5>₦{{Number(billdata.reward.cova_point_in_naira).toLocaleString()}} <span @click="applyDiscount = !applyDiscount; discountPoint = ''">{{applyDiscount ? 'UNAPPLY' : 'APPLY'}}</span></h5>
                    </div>
                  </div>

                  <div class="discount-section" v-if="applyDiscount">
                    <h4 class="custom-discount-text">Apply Custom Discount</h4>
                    <section class="mt-4">
                      <div class="form-group">
                        <label for="discount-point">Discount amount:</label>
                        <input type="number" class="form-control" id="discount-point" placeholder="Enter discount amount" @input="discountPoint && (discountPoint = Math.min(discountPoint, Number(billdata.amount)))" v-model.number="discountPoint">
                      </div>
                    </section>
                  </div>
                </div>
              </div>
              <div class="extend-duration-btn">
                <button
                  @click="discountPoint = ''; applyDiscount = false; "
                  class="btn cancel2"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  Cancel
                </button>
                <button
                  :disabled="loading"
                  class="btn continue3"
                  @click="finalizeBill()"
                >
                  Confirm
                  <i
                    class="fa fa-spinner fa-spin ml-3 f-12 btn-loader"
                    v-if="loading"
                  ></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          class="modal center-modal fade"
          id="transactionPin"
          tabindex="-1"
          aria-labelledby="transactionPin"
          aria-hidden="true"
        >
          <div
            class="modal-dialog modal-dialog-center"
            style="margin-bottom: 50px;"
          >
            <div class="modal-content">
              <div
                class="modal-header pt-4 pb-2"
                style="margin: 0 14px; padding: inherit;"
              >
                <h5 class="modal-title title-modal" id="rc">
                  Enter Transaction Pin
                </h5>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <!-- <hr /> -->
              <div class="modal-body">
                <div class="pin-wrapper">
                  <input
                    v-for="(digit, index) in pin"
                    :key="index"
                    type="text"
                    maxlength="1"
                    :id="index"
                    class="pin-input form-control"
                    v-model="pin[index]"
                    @input="onInput(index, $event)"
                    @keydown.backspace="onBackspace(index)"
                  />
                </div>
              </div>
              <div class="extend-duration-btn">
                <!-- <button
                  class="btn cancel2"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  Cancel
                </button> -->
                <button
                  :disabled="loading"
                  class="btn continue3"
                  @click="submitBillwithPin()"
                >
                  Submit
                  <i
                    class="fa fa-spinner fa-spin ml-3 f-12 btn-loader"
                    v-if="loading"
                  ></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div v-if="loading">
            <PageLoader></PageLoader>
        </div>
    </div>
</template>
<script>
// import { type } from "os";
import { Service } from "../../store/service";
import PageLoader from "../../components/PageLoader.vue";
    const Api = new Service();
    import $ from "jquery";
        export default {
            name: "ConfirmPayment",
            components: {
              PageLoader
            },
            // props: {
            //   billdata: {
            //     type: Object,
            //     default: null
            //   },
            // },
            data() {
                return {
                  loading: false,
                  discountPoint: "",
                  applyDiscount: false,
                  pin: ["", "", "", ""],
                  fullPin: null,
                  billdata: {},
                }
            },
            created() {
              this.$root.$refs.openConfirm = this;
            },
            mounted() {
              // console.log("Bills Onbject", this.billdata)
            },
            methods: {
                // routeTo(route) {
                //     this.$router.push({
                //     path: route
                //     })
                //     .catch(() => {});
                // },
                setDataSuccess(data) {
                  this.billdata = { ...data };
                },
                // Do not delet, its used to open the modal from another component
                openConfirmationModal() {
                    $("#confirmPaymentBill")
                    .addClass("fade")
                    .modal("show");
                },
                finalizeBill() {
                  if (this.discountPoint < 1000 && this.applyDiscount == true) {
                    return this.$store.commit("setApiFailed", "Discount should not be less than ₦1,000");
                  }
                  $("#confirmPaymentBill")
                    .removeClass("fade")
                    .modal("hide");
                  
                  $("#transactionPin")
                    .addClass("fade")
                    .modal("show");
                },
                onInput(index, event) {
                  const value = event.target.value;

                  // Allow only numbers
                  if (!/^\d$/.test(value)) {
                    this.pin[index] = "";
                    return;
                  }

                  // Move to next input
                  if (index < 3) {
                    event.target.nextElementSibling?.focus();
                  }

                  // Optional: PIN completed
                  if (this.pin.join("").length === 4) {
                    this.fullPin = this.pin.join("");
                  }
                },

                onBackspace(index) {
                  if (this.pin[index] === "" && index > 0) {
                    this.$nextTick(() => {
                      document.querySelectorAll(".pin-input")[index - 1].focus();
                    });
                  }
                },
                async submitBillwithPin() {
                  if (this.fullPin == '' || this.fullPin == null) {
                    return this.$store.commit("setApiFailed", "Please enter pin");
                  }
                  if (this.pin.length < 4) {
                    return this.$store.commit("setApiFailed", "Pin not complet");
                  }
                  this.loading = true;
                  try {
                    await Api.postRequest(`verify-transaction-pin`, {pin: this.fullPin})
                    .then(res => {
                      this.loading = false;
                      this.fullPin = null;
                      this.pin = ["", "", "", ""];
                      // console.log("pin verified", res)
                      if (res.data.success) {
                        $("#transactionPin")
                        .removeClass("fade")
                        .modal("hide");
                        this.openConfirmationRecepit();
                        // return this.$store.commit("setApiSuccess", "Success");
                      }
                      if (res.data.error) {
                        return this.$store.commit("setApiFailed", res.data.error);
                      }
                    })
                    .catch(err => {
                      console.log(err);
                      this.loading = false;
                    });
                  } finally {
                    // console.log("closed")
                  }                
                },
                openConfirmationRecepit() {
                  // console.log("Open modal Reciept")
                  this.$emit('call-parent', { sentData: {coverPoint: Number(this.discountPoint)} });
                  // this.$root.$refs.openSuccess.openSuccessModal();
                },

            },
        }
        
</script>

<style scoped lang="scss">
.extend-duration-btn {
  padding: 10px 14px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-bottom: 30px;

  .cancel2 {
    border-radius: 8px;
    height: 44px;
    // border: 1px solid #d0d5dd;
    color: #0022AA;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    height: 48px;
    width: 100%;
    box-shadow: none;
    outline: 0;
    background: #E6F0FA;
  }

  .continue3 {
    border-radius: 8px;
    height: 44px;
    background: #0033EA;
    color: #ffffff;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    height: 48px;
    width: 100%;
    box-shadow: none;
    outline: 0;
  }
}

.billAmount {
  font-family: Lato;
  font-weight: 700;
  font-size: 26px;
  text-align: center;
  color: #1A1A1A;
}
.discount-amount {
  font-family: Lato;
  font-weight: 400;
  font-size: 18px;
  text-align: center;
  text-decoration: line-through;
  color: #9CA3AF;
  // line-height: 40px;
  margin-bottom: 20px;
}

.confirmation-holder {
  background: #F8F9FA;
  border-radius: 8px;
  padding: 10px;
  h5, h6 {
    font-family: Lato;
    font-size: 14px;
    line-height: 33px;
    color: #555555;
  }
  h6 {
    font-weight: 400;
    text-align: right !important;
  }
  h5 {
    font-weight: 500;
    text-transform: capitalize;
    span {
      background: #FFB100;
      padding: 4px 8px;
      border-radius: 50px;
      font-size: 10px;
      color: #ffffff;
      margin-left: 5px;
      font-family: Lato;
      cursor: pointer;
    }
  }
}
.discount-section:not(:last-child) {
  border-bottom: 1px dashed #E6E9EC;
}
.discount-section  > div {
  display: flex;
  justify-content: space-between;
  gap: 26px;
}
.confirmation-holder {
  // display: flex;
  // justify-content: space-between;
}

label {
  font-family: Lato;
    font-weight: 500;
    font-size: 16px;
    color: #555555;
    text-align: left;
    display: flex;
}
input {
    height: 48px;
    border-radius: 4px;
    border: 1px solid #E6E9EC;
    background: #F8F9FA !important;
    // border: #E6E9EC;
//   color: #aaadba;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    // line-height: 150%;
    outline: 0 !important;
    box-shadow: none !important;
}
.custom-discount-text {
  font-family: Lato;
  font-weight: 600;
  font-size: 16px;
  line-height: 30px;
  color: #1A1A1A;
  text-align: left;
  margin-top: 30px;

}

// transaction pin sections starts
.pin-wrapper {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.pin-input {
  width: 60px;
  height: 60px;
  font-size: 24px;
  text-align: center;
  border: 1px solid #ccc;
  border-radius: 6px;
  background: #F7F7F7 !important;
}
// transactinn pin section ends

@media only screen and (max-width: 599px) {
  .confirmation-holder {
    h5, h6 {
      font-size: 12px;
    }
  }
}
</style>